import React from 'react';
import { createUseStyles } from 'react-jss';

import MenuItem from './MenuItem';

const useStyles = createUseStyles((theme) => ({
  items: {
    margin: 0,
    padding: 0,
    composes: 'flexColumn',
    marginBottom: theme.spacing(1),
  },
}));

const MenuOptions = ({
  open,
  onOpen,
  children,
  label,
  defaultOption,
  value,
}) => {
  const classes = useStyles();

  return (
    <>
      <MenuItem
        label={label}
        text={value || defaultOption}
        vertical
        onClick={onOpen}
        open={open} 
        customValue={defaultOption} 
      />
      {open && (
        <ul className={classes.items}>
          {children}
        </ul>
      )}
    </>
  );
}

export default MenuOptions;